const getConcurrentUsers = (state: AnyFixMe) => state.concurrentUsers;

const isConcurrentUsersEditing = (state: AnyFixMe) =>
  !!state.concurrentUsers.concurrentUsers.length;

export { getConcurrentUsers, isConcurrentUsersEditing };
